declare namespace $ {

	type $mol_string_button__value_shm_hitalama_map_widget_page_1 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_page['title'] >
		,
		ReturnType< $mol_string_button['value'] >
	>
	type $mol_switch__value_shm_hitalama_map_widget_page_2 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_page['tab'] >
		,
		ReturnType< $mol_switch['value'] >
	>
	type $mol_switch__options_shm_hitalama_map_widget_page_3 = $mol_type_enforce<
		({ 
			'general': string,
			'text': string,
		}) 
		,
		ReturnType< $mol_switch['options'] >
	>
	type $mol_view__attr_shm_hitalama_map_widget_page_4 = $mol_type_enforce<
		({ 
			'title': ReturnType< $shm_hitalama_map_widget_page['widget_type_title'] >,
		})  & ReturnType< $mol_view['attr'] >
		,
		ReturnType< $mol_view['attr'] >
	>
	type $mol_view__sub_shm_hitalama_map_widget_page_5 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_hitalama_map_widget_page_6 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_hitalama_map_widget_page_7 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_hitalama_map_widget_page_8 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_page['tools'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_hitalama_map_widget_page_9 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_paragraph__title_shm_hitalama_map_widget_page_10 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_number__value_shm_hitalama_map_widget_page_11 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_page['x'] >
		,
		ReturnType< $mol_number['value'] >
	>
	type $mol_number__Dec_shm_hitalama_map_widget_page_12 = $mol_type_enforce<
		any
		,
		ReturnType< $mol_number['Dec'] >
	>
	type $mol_number__Inc_shm_hitalama_map_widget_page_13 = $mol_type_enforce<
		any
		,
		ReturnType< $mol_number['Inc'] >
	>
	type $mol_paragraph__title_shm_hitalama_map_widget_page_14 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_number__value_shm_hitalama_map_widget_page_15 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_page['widget_width'] >
		,
		ReturnType< $mol_number['value'] >
	>
	type $mol_number__Dec_shm_hitalama_map_widget_page_16 = $mol_type_enforce<
		any
		,
		ReturnType< $mol_number['Dec'] >
	>
	type $mol_number__Inc_shm_hitalama_map_widget_page_17 = $mol_type_enforce<
		any
		,
		ReturnType< $mol_number['Inc'] >
	>
	type $mol_view__sub_shm_hitalama_map_widget_page_18 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_paragraph__title_shm_hitalama_map_widget_page_19 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_number__value_shm_hitalama_map_widget_page_20 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_page['y'] >
		,
		ReturnType< $mol_number['value'] >
	>
	type $mol_number__Dec_shm_hitalama_map_widget_page_21 = $mol_type_enforce<
		any
		,
		ReturnType< $mol_number['Dec'] >
	>
	type $mol_number__Inc_shm_hitalama_map_widget_page_22 = $mol_type_enforce<
		any
		,
		ReturnType< $mol_number['Inc'] >
	>
	type $mol_paragraph__title_shm_hitalama_map_widget_page_23 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_number__value_shm_hitalama_map_widget_page_24 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_page['height'] >
		,
		ReturnType< $mol_number['value'] >
	>
	type $mol_number__Dec_shm_hitalama_map_widget_page_25 = $mol_type_enforce<
		any
		,
		ReturnType< $mol_number['Dec'] >
	>
	type $mol_number__Inc_shm_hitalama_map_widget_page_26 = $mol_type_enforce<
		any
		,
		ReturnType< $mol_number['Inc'] >
	>
	type $mol_view__sub_shm_hitalama_map_widget_page_27 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_paragraph__title_shm_hitalama_map_widget_page_28 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_number__value_shm_hitalama_map_widget_page_29 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_page['z'] >
		,
		ReturnType< $mol_number['value'] >
	>
	type $mol_number__Dec_shm_hitalama_map_widget_page_30 = $mol_type_enforce<
		any
		,
		ReturnType< $mol_number['Dec'] >
	>
	type $mol_number__Inc_shm_hitalama_map_widget_page_31 = $mol_type_enforce<
		any
		,
		ReturnType< $mol_number['Inc'] >
	>
	type $mol_check_box__title_shm_hitalama_map_widget_page_32 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_check_box['title'] >
	>
	type $mol_check_box__checked_shm_hitalama_map_widget_page_33 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_page['auto_height'] >
		,
		ReturnType< $mol_check_box['checked'] >
	>
	type $mol_view__sub_shm_hitalama_map_widget_page_34 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_hitalama_map_widget_page_35 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $shm_hitalama_map_fontsize__font_size_shm_hitalama_map_widget_page_36 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_page['font_size'] >
		,
		ReturnType< $shm_hitalama_map_fontsize['font_size'] >
	>
	type $mol_labeler__title_shm_hitalama_map_widget_page_37 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__content_shm_hitalama_map_widget_page_38 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_labeler['content'] >
	>
	type $mol_string__value_shm_hitalama_map_widget_page_39 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_page['font_family'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_string__hint_shm_hitalama_map_widget_page_40 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_string['hint'] >
	>
	type $mol_labeler__title_shm_hitalama_map_widget_page_41 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__content_shm_hitalama_map_widget_page_42 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_labeler['content'] >
	>
	type $mol_view__sub_shm_hitalama_map_widget_page_43 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $shm_hitalama_color_pick__color_shm_hitalama_map_widget_page_44 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_page['color'] >
		,
		ReturnType< $shm_hitalama_color_pick['color'] >
	>
	type $shm_hitalama_color_pick__color_default_shm_hitalama_map_widget_page_45 = $mol_type_enforce<
		string
		,
		ReturnType< $shm_hitalama_color_pick['color_default'] >
	>
	type $mol_string__value_shm_hitalama_map_widget_page_46 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_page['color'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_labeler__title_shm_hitalama_map_widget_page_47 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__content_shm_hitalama_map_widget_page_48 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_labeler['content'] >
	>
	type $mol_view__sub_shm_hitalama_map_widget_page_49 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $shm_hitalama_color_pick__color_shm_hitalama_map_widget_page_50 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_page['background_color'] >
		,
		ReturnType< $shm_hitalama_color_pick['color'] >
	>
	type $shm_hitalama_color_pick__color_default_shm_hitalama_map_widget_page_51 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_page['background_color_default'] >
		,
		ReturnType< $shm_hitalama_color_pick['color_default'] >
	>
	type $mol_string__value_shm_hitalama_map_widget_page_52 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_page['background_color'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_number__value_shm_hitalama_map_widget_page_53 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_page['background_opacity_percent'] >
		,
		ReturnType< $mol_number['value'] >
	>
	type $mol_number__Dec_shm_hitalama_map_widget_page_54 = $mol_type_enforce<
		any
		,
		ReturnType< $mol_number['Dec'] >
	>
	type $mol_number__Inc_shm_hitalama_map_widget_page_55 = $mol_type_enforce<
		any
		,
		ReturnType< $mol_number['Inc'] >
	>
	type $mol_search__query_shm_hitalama_map_widget_page_56 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_page['background_opacity_percent_selected'] >
		,
		ReturnType< $mol_search['query'] >
	>
	type $mol_search__anchor_content_shm_hitalama_map_widget_page_57 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_search['anchor_content'] >
	>
	type $mol_search__suggests_shm_hitalama_map_widget_page_58 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_page['opacity_percent_suggests'] >
		,
		ReturnType< $mol_search['suggests'] >
	>
	type $mol_view__sub_shm_hitalama_map_widget_page_59 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_labeler__title_shm_hitalama_map_widget_page_60 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__content_shm_hitalama_map_widget_page_61 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_labeler['content'] >
	>
	type $mol_view__sub_shm_hitalama_map_widget_page_62 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $shm_hitalama_color_pick__color_shm_hitalama_map_widget_page_63 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_page['border_color'] >
		,
		ReturnType< $shm_hitalama_color_pick['color'] >
	>
	type $shm_hitalama_color_pick__color_default_shm_hitalama_map_widget_page_64 = $mol_type_enforce<
		string
		,
		ReturnType< $shm_hitalama_color_pick['color_default'] >
	>
	type $mol_string__value_shm_hitalama_map_widget_page_65 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_page['border_color'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $shm_hitalama_map_borderwidth__border_width_shm_hitalama_map_widget_page_66 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_page['border_width'] >
		,
		ReturnType< $shm_hitalama_map_borderwidth['border_width'] >
	>
	type $mol_view__style_shm_hitalama_map_widget_page_67 = $mol_type_enforce<
		({ 
			'borderBottomStyle': ReturnType< $shm_hitalama_map_widget_page['border_style'] >,
		}) 
		,
		ReturnType< $mol_view['style'] >
	>
	type $mol_view__sub_shm_hitalama_map_widget_page_68 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__style_shm_hitalama_map_widget_page_69 = $mol_type_enforce<
		({ 
			'borderBottomStyle': ReturnType< $shm_hitalama_map_widget_page['border_style_option'] >,
		}) 
		,
		ReturnType< $mol_view['style'] >
	>
	type $mol_view__sub_shm_hitalama_map_widget_page_70 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_select__value_shm_hitalama_map_widget_page_71 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_page['border_style'] >
		,
		ReturnType< $mol_select['value'] >
	>
	type $mol_select__Filter_shm_hitalama_map_widget_page_72 = $mol_type_enforce<
		any
		,
		ReturnType< $mol_select['Filter'] >
	>
	type $mol_select__trigger_content_shm_hitalama_map_widget_page_73 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_page['border_style_content'] >
		,
		ReturnType< $mol_select['trigger_content'] >
	>
	type $mol_select__option_content_shm_hitalama_map_widget_page_74 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_page['border_style_option_content'] >
		,
		ReturnType< $mol_select['option_content'] >
	>
	type $mol_select__options_shm_hitalama_map_widget_page_75 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_select['options'] >
	>
	type $mol_number__value_shm_hitalama_map_widget_page_76 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_page['border_opacity_percent'] >
		,
		ReturnType< $mol_number['value'] >
	>
	type $mol_number__Dec_shm_hitalama_map_widget_page_77 = $mol_type_enforce<
		any
		,
		ReturnType< $mol_number['Dec'] >
	>
	type $mol_number__Inc_shm_hitalama_map_widget_page_78 = $mol_type_enforce<
		any
		,
		ReturnType< $mol_number['Inc'] >
	>
	type $mol_search__query_shm_hitalama_map_widget_page_79 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_page['border_opacity_percent_selected'] >
		,
		ReturnType< $mol_search['query'] >
	>
	type $mol_search__anchor_content_shm_hitalama_map_widget_page_80 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_search['anchor_content'] >
	>
	type $mol_search__suggests_shm_hitalama_map_widget_page_81 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_page['opacity_percent_suggests'] >
		,
		ReturnType< $mol_search['suggests'] >
	>
	type $mol_view__sub_shm_hitalama_map_widget_page_82 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_labeler__title_shm_hitalama_map_widget_page_83 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__content_shm_hitalama_map_widget_page_84 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_labeler['content'] >
	>
	type $mol_view__sub_shm_hitalama_map_widget_page_85 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $shm_button_copy__hint_shm_hitalama_map_widget_page_86 = $mol_type_enforce<
		string
		,
		ReturnType< $shm_button_copy['hint'] >
	>
	type $shm_button_copy__text_shm_hitalama_map_widget_page_87 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_page['text'] >
		,
		ReturnType< $shm_button_copy['text'] >
	>
	type $shm_button_copy__button_sub_shm_hitalama_map_widget_page_88 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $shm_button_copy['button_sub'] >
	>
	type $mol_scroll__sub_shm_hitalama_map_widget_page_89 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_scroll['sub'] >
	>
	type $mol_labeler__label_shm_hitalama_map_widget_page_90 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_labeler['label'] >
	>
	type $mol_labeler__content_shm_hitalama_map_widget_page_91 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_labeler['content'] >
	>
	type $mol_string__value_shm_hitalama_map_widget_page_92 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_page['external_link'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_string__hint_shm_hitalama_map_widget_page_93 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_string['hint'] >
	>
	type $mol_labeler__title_shm_hitalama_map_widget_page_94 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__content_shm_hitalama_map_widget_page_95 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_labeler['content'] >
	>
	type $mol_paragraph__title_shm_hitalama_map_widget_page_96 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_list__sub_shm_hitalama_map_widget_page_97 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_page['data_rows'] >
		,
		ReturnType< $mol_list['sub'] >
	>
	type $mol_view__sub_shm_hitalama_map_widget_page_98 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_list__sub_shm_hitalama_map_widget_page_99 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_page['type_settings'] >
		,
		ReturnType< $mol_list['sub'] >
	>
	type $mol_check_box__title_shm_hitalama_map_widget_page_100 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_check_box['title'] >
	>
	type $mol_check_box__checked_shm_hitalama_map_widget_page_101 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_page['hide_head_tools'] >
		,
		ReturnType< $mol_check_box['checked'] >
	>
	type $mol_textarea__value_shm_hitalama_map_widget_page_102 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_page['data_value_text'] >
		,
		ReturnType< $mol_textarea['value'] >
	>
	type $shm_hitalama_map_widget_tools__widget_shm_hitalama_map_widget_page_103 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_page['widget'] >
		,
		ReturnType< $shm_hitalama_map_widget_tools['widget'] >
	>
	type $shm_hitalama_map_widget_tools__Map_page_shm_hitalama_map_widget_page_104 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_page['Map_page'] >
		,
		ReturnType< $shm_hitalama_map_widget_tools['Map_page'] >
	>
	type $shm_hitalama_map_widget_tools__settings_tool_visible_shm_hitalama_map_widget_page_105 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $shm_hitalama_map_widget_tools['settings_tool_visible'] >
	>
	type $shm_hitalama_map_widget_contextmenu__widget_shm_hitalama_map_widget_page_106 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_page['widget'] >
		,
		ReturnType< $shm_hitalama_map_widget_contextmenu['widget'] >
	>
	type $shm_hitalama_map_widget_contextmenu__Map_page_shm_hitalama_map_widget_page_107 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_page['Map_page'] >
		,
		ReturnType< $shm_hitalama_map_widget_contextmenu['Map_page'] >
	>
	type $shm_hitalama_text_editor__value_shm_hitalama_map_widget_page_108 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_page['text'] >
		,
		ReturnType< $shm_hitalama_text_editor['value'] >
	>
	type $shm_hitalama_text_editor__owner_shm_hitalama_map_widget_page_109 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_page['widget'] >
		,
		ReturnType< $shm_hitalama_text_editor['owner'] >
	>
	type $shm_hitalama_text_editor__images_enabled_shm_hitalama_map_widget_page_110 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_page['markdown_images_enabled'] >
		,
		ReturnType< $shm_hitalama_text_editor['images_enabled'] >
	>
	type $mol_labeler__title_shm_hitalama_map_widget_page_111 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_page['data_key'] >
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__content_shm_hitalama_map_widget_page_112 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_labeler['content'] >
	>
	export class $shm_hitalama_map_widget_page extends $shm_hitalama_page {
		history_edit_start( next?: any ): any
		history_edit_end( next?: any ): any
		title( next?: string ): string
		Title( ): $mol_string_button
		tab( next?: string ): string
		Tabs( ): $mol_switch
		widget_type_title( ): string
		Widget_type_icon( ): $mol_icon_square_outline
		Widget_type( ): $mol_view
		Heading_tabs( ): $mol_view
		Heading( ): $mol_view
		Up( ): ReturnType< ReturnType< $shm_hitalama_map_widget_page['Tools'] >['Up'] >
		Down( ): ReturnType< ReturnType< $shm_hitalama_map_widget_page['Tools'] >['Down'] >
		Lock( ): ReturnType< ReturnType< $shm_hitalama_map_widget_page['Tools'] >['Lock'] >
		Fullscreen( ): ReturnType< ReturnType< $shm_hitalama_map_widget_page['Tools'] >['Fullscreen'] >
		Delete( ): ReturnType< ReturnType< $shm_hitalama_map_widget_page['Tools'] >['Delete'] >
		code_widget_tool_visible( ): ReturnType< ReturnType< $shm_hitalama_map_widget_page['Tools'] >['code_widget_tool_visible'] >
		Customize( ): ReturnType< ReturnType< $shm_hitalama_map_widget_page['Contextmenu'] >['Customize'] >
		Make_extension( ): ReturnType< ReturnType< $shm_hitalama_map_widget_page['Contextmenu'] >['Make_extension'] >
		Quick_access( ): ReturnType< ReturnType< $shm_hitalama_map_widget_page['Contextmenu'] >['Quick_access'] >
		To_front( ): ReturnType< ReturnType< $shm_hitalama_map_widget_page['Contextmenu'] >['To_front'] >
		To_back( ): ReturnType< ReturnType< $shm_hitalama_map_widget_page['Contextmenu'] >['To_back'] >
		tools( ): readonly(any)[]
		Tool_icons( ): $mol_view
		Z_jump( ): $mol_view
		X_label( ): $mol_paragraph
		x( next?: number ): number
		X( ): $mol_number
		Width_label( ): $mol_paragraph
		widget_width( next?: number ): number
		Width( ): $mol_number
		Xw_row( ): $mol_view
		Y_label( ): $mol_paragraph
		y( next?: number ): number
		Y( ): $mol_number
		Height_label( ): $mol_paragraph
		height( next?: number ): number
		Height( ): $mol_number
		Yh_row( ): $mol_view
		Z_label( ): $mol_paragraph
		z( next?: number ): number
		Z( ): $mol_number
		auto_height( next?: boolean ): boolean
		Auto_height( ): $mol_check_box
		Z_row( ): $mol_view
		Size_section( ): $mol_view
		font_size( next?: number ): number
		Font_size( ): $shm_hitalama_map_fontsize
		Font_size_labeler( ): $mol_labeler
		font_family( next?: string ): string
		Font_family( ): $mol_string
		Font_family_labeler( ): $mol_labeler
		Font_row( ): $mol_view
		color( next?: string ): string
		Font_color( ): $shm_hitalama_color_pick
		Font_color_hex( ): $mol_string
		Font_color_labeler( ): $mol_labeler
		Font_section( ): $mol_view
		background_color( next?: string ): string
		background_color_default( ): string
		Background_color( ): $shm_hitalama_color_pick
		Background_hex( ): $mol_string
		background_opacity_percent_selected( next?: string ): string
		background_opacity_percent( next?: number ): number
		Background_opacity( ): $mol_number
		opacity_percent_suggests( ): readonly(string)[]
		Background_opacity_search( ): $mol_search
		Background_opacity_wrap( ): $mol_view
		Background_labeler( ): $mol_labeler
		Background_section( ): $mol_view
		border_color( next?: string ): string
		Border_color( ): $shm_hitalama_color_pick
		Border_hex( ): $mol_string
		border_width( next?: number ): number
		Border_width( ): $shm_hitalama_map_borderwidth
		border_style( ): string
		Border_style_current_line( ): $mol_view
		Border_style_current( ): $mol_view
		Border_style_current_none( ): $mol_icon_close
		border_style_content( ): readonly(any)[]
		border_style_option( id: any): string
		Border_style_option_line( id: any): $mol_view
		Border_style_option( id: any): $mol_view
		Border_style_none( ): $mol_icon_close
		border_style_option_content( id: any): readonly(any)[]
		Border_style( ): $mol_select
		border_opacity_percent_selected( next?: string ): string
		border_opacity_percent( next?: number ): number
		Border_opacity( ): $mol_number
		Border_opacity_search( ): $mol_search
		Border_opacity_wrap( ): $mol_view
		Border_labeler( ): $mol_labeler
		Border_section( ): $mol_view
		general_body( ): readonly(any)[]
		text( next?: string ): string
		markdown_images_enabled( ): boolean
		Text_copy_icon( ): $mol_icon_content_copy
		Text_copy( ): $shm_button_copy
		Text_scroll( ): $mol_scroll
		Text_labeler( ): $mol_labeler
		text_visible( ): readonly(any)[]
		external_link( next?: string ): string
		External_link( ): $mol_string
		External_link_labeler( ): $mol_labeler
		Data_title( ): $mol_paragraph
		data_rows( ): readonly(any)[]
		Data_list( ): $mol_list
		Data_section( ): $mol_view
		type_settings( ): readonly(any)[]
		Type_settings( ): $mol_list
		type_settings_visible( ): readonly(any)[]
		hide_head_tools( next?: boolean ): boolean
		Hide_head_tools( ): $mol_check_box
		data_key( id: any): string
		data_value_text( id: any, next?: string ): string
		Data_value( id: any): $mol_textarea
		resize_side( ): string
		Map_page( ): $shm_hitalama_map_page
		widget( ): $shm_hitalama_map_widget
		text_focus( ): any
		event( ): ({ 
			focusin( next?: ReturnType< $shm_hitalama_map_widget_page['history_edit_start'] > ): ReturnType< $shm_hitalama_map_widget_page['history_edit_start'] >,
			focusout( next?: ReturnType< $shm_hitalama_map_widget_page['history_edit_end'] > ): ReturnType< $shm_hitalama_map_widget_page['history_edit_end'] >,
		})  & ReturnType< $shm_hitalama_page['event'] >
		head( ): readonly(any)[]
		Tools( ): $shm_hitalama_map_widget_tools
		Contextmenu( ): $shm_hitalama_map_widget_contextmenu
		opacity_percent_options( ): readonly(number)[]
		body( ): ReturnType< $shm_hitalama_map_widget_page['general_body'] >
		Text( ): $shm_hitalama_text_editor
		general_tail( ): readonly(any)[]
		Data_labeler( id: any): $mol_labeler
	}
	
}

//# sourceMappingURL=page.view.tree.d.ts.map